import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authSlice } from "@/features/auth";
import { workContractSlice } from "@/features/hr/contracts";
import { completenessSlice } from "@/features/hr/hiring";
import { settingsSlice } from "@/features/settings";
import { baseApi } from "@/shared/api";
import { communityApi, communitySessionListener } from "@/shared/api/community";
import { oneCApi } from "@/shared/api/oneC";
import { apiErrorLogger } from "@/shared/support";

export const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [completenessSlice.name]: completenessSlice.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [oneCApi.reducerPath]: oneCApi.reducer,
    [communityApi.reducerPath]: communityApi.reducer,
    [workContractSlice.name]: workContractSlice.reducer,
    [settingsSlice.name]: settingsSlice.reducer,
  },
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: {
        ignoredPaths: [
          `${baseApi.reducerPath}.mutations`,
          `${oneCApi.reducerPath}.mutations`,
          `${communityApi.reducerPath}.mutations`,
        ],
      },
    })
      .prepend(communitySessionListener.middleware)
      .concat(apiErrorLogger, baseApi.middleware, oneCApi.middleware, communityApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
